var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {}, [
    _c("div", { staticClass: "alert alert-danger pt-4" }, [
      _c("p", [
        _c("strong", [
          _c("i", { staticClass: "lh-inherit far fa-info-circle" }),
          _vm._v(" " + _vm._s(_vm._f("trans")("Something went wrong"))),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm._f("trans")(
              this.getTranslatedError(_vm.currentJob.apiJob.errors[0].code)
            )
          )
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }